import services from "@/services";

const state = {
  items: [],
  data: {},
  promoListData: [],
  promoListSetting: {},
};

const mutations = {
  storePromoListSetting(state, data) {
    state.promoListSetting = data;
  },
  storePromoListData(state, data) {
    state.promoListData = data;
  },
};

const actions = {
  saveDataCategory({ dispatch }, body) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .post("homepagecategory", body)
        .then((response) => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  saveDataTab({ dispatch }, body) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .post("homepagetab", body)
        .then((response) => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  uploadIcon({ commit, dispatch }, payload) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .post("homepagecategory/icon", payload)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  fetch(data) {
    services.setHeader();
    return new Promise((resolve, reject) => {
      services
        .get("homepage")
        .then((response) => {
          resolve(response.data.data.items);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getPromoList({ commit, dispatch }, param) {
    dispatch("setLoadingTable", true, { root: true })
    services.setHeader();
    return new Promise((resolve, reject) => {
      services
        .get("promo-page-list", param)
        .then((response) => {

          commit("storePromoListData", response.data.data.items)
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingTable", false, { root: true })
        })
    });
  },
  getPromoListSetting({ commit }, param) {
    services.setHeader();
    return new Promise((resolve, reject) => {
      services
        .get("promo-page-setting", param)
        .then((response) => {
          
          commit("storePromoListSetting", response.data.data.Item)
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updatePromoListSetting({ commit, dispatch }, payload) {
    dispatch("setLoadingGlobal", true, { root: true })
    services.setHeader();
    return new Promise((resolve, reject) => {
      services
        .put("promo-page-setting", payload)
        .then((response) => {
          commit("storePromoListSetting", response.data.data.item)
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
